<template>
    <section class="practice">
        <div class="row">
             <aside class="col-md-3 col-sm-12 cus-sidebar">
                <practiceSidebar />
            </aside>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" id="content" class="content dailyReport col-md-9 col-sm-12">
                <div class="material-box bg-white">

                    <div class="col-md-12 top-title">
                        <h3>Weekly Report</h3>
                    </div>
                    <!-- begin section-container -->
                    <div class="col-md-12">
                        <div class="section-container section-with-top-border patient_report">
                            <div class="inner_patient_report">
                                <div class="row" style="align-items: flex-end;">
                                    <div class="col-lg-3 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Start Date:</label>
                                            <input type="date" class=" form-control" v-model="form.date" @change="datechange">
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>End Date:</label>
                                            <input type="text" readonly="readonly" value="" class="form-control"
                                                v-model="weekdate" id="EndDate">
                                        </div>
                                    </div>
                                    <!-- <div class="col-lg-2 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <label>Select User </label>
                                            <b-form-select id="Prefix" v-model="form.UserID" :options="users" value-field="id"
                                                text-field="name" @change="userchange">
                                            </b-form-select>
                                        </div>
                                    </div> -->
                                    <div class="col-lg-4 col-md-6 col-sm-6">
                                        <div class="form-group">
                                            <button class="btn btn-default btn-primary btn-blue mr-1" @click="weeklyReport">Submit</button>
                                            <button class="btn btn-default btn-white" @click="printReport"><i class="fa fa-print"></i> Print Report </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- begin panel -->

                            <div id="print-report">
                                <div class="col-lg-12 title">
                                    <!-- 		<h4 align="center" class="color-grey" style="font-family:Nunito">Weekly Report</h4> -->
                                    <h4 class="color-grey">{{ loginUser.PracticeName }}{{ user.name ? " - " + user.name : ""}}</h4>
                                    <h4 class="color-grey"><b>Weekly Report for {{ formatDate(this.form.date) }}</b> to
                                        <b>{{ formatDate(weekdate) }}</b>
                                    </h4>
                                </div>

                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="table-responsive w-table-responsive" v-for="(report,index) in reports" :key="index">
                                                <table id="report-tbl" class="table condenced-table daily-repot-table table-td-valign-middle table-td-valign-main weekly comnTbl">
                                                    <thead>
                                                        <tr>
                                                            <th><b>{{ report[0].title }}: </b></th>
                                                            <th>{{tableTitle(report[0].title).c1}}</th>
                                                            <th>{{tableTitle(report[0].title).c2}}</th>
                                                            <th>Difference</th>
                                                            <th>Success Rate</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(daily,ind) in report" :key="ind+'.'+index">
                                                            <td>{{daily.day_name}} : </td>
                                                            <td>{{ daily['Focus' + (index + 1) + 'Goal'] }}</td>
                                                            <td>{{ daily['Focus' + (index + 1) + 'Actual'] }}</td>
                                                            <td>{{ calDifference(daily['Focus' + (index + 1) + 'Goal'], daily['Focus' + (index + 1) + 'Actual'], index === 4) }}</td>
                                                            <td>{{calculatePer(daily['Focus' + (index + 1) + 'Actual'],daily['Focus' + (index + 1) + 'Goal'])}}%</td>
                                                        </tr>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td><b>Total:</b></td>
                                                            <td>{{ calculateColumnTotal('Focus' + (index + 1) + 'Goal', index) }}</td>
                                                            <td>{{ calculateColumnTotal('Focus' + (index + 1) + 'Actual', index) }}</td>
                                                            <td>{{ calculateColumnTotalDifference('Focus' + (index + 1) + 'Goal', 'Focus' + (index + 1) + 'Actual', index === 4, index) }}</td>
                                                            <td>{{ calculateColumnTotalSuccessRate('Focus' + (index + 1) + 'Actual', 'Focus' + (index + 1) + 'Goal', index) }}%</td>
                                                        </tr>
                                                    </tfoot>            
                                                </table>
                                            </div>

                                            <div class="fTxt"> <br>
                                                <span class="pull-left"><b>{{ today() }}</b></span> <span
                                                    class="pull-right"><b style="width:190px; display:block; letter-spacing: 0.6px;">{{ loginUser.PracticeName }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- end panel -->
                            </div>
                        </div>
                    </div>
                    <!-- end section-container -->

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';
import practiceSidebar from "./../Practice/components/Sidebar.vue";
import userAPI from "../userApi";
import moment from 'moment'
import jsPDF from 'jspdf';

Vue.use(jsPDF)
export default {
    name: "practice_dashboard",
    components: {
        practiceSidebar,
    },
    data() {
        return {
            isLoading: false,
            date: moment().subtract(1, 'weeks').startOf('isoWeek').format("dddd, MMMM D, YYYY"),
            loginUser: {},
            table: {},
            users: [{
                id: 0,
                name: 'Practice'
            }],
            user:{},
            form: {
                UserID: 0,
                date: moment().subtract(1, 'weeks').startOf('isoWeek').format('Y-MM-DD'),
            },
            monthlyReport: {},
            years: [],
            reports: {},
            weekdate: '',
        }
    },
    methods: {
        tableTitle(title) {
            let titleArr = {
                c1: '',
                c2: ''
            };
            if (title == 'New Patient') {
                titleArr.c1 = 'Goal'
                titleArr.c2 = 'Actual'
                return titleArr;
            } else if (title == 'Report of Findings') {
                titleArr.c1 = 'Arrived';
                titleArr.c2 = 'Started';
                return titleArr;
            } else if (title == 'Patient Visits') {
                titleArr.c1 = 'Goal'
                titleArr.c2 = 'Actual'
                return titleArr;
            } else if (title == 'Care Plan Renewals') {
                titleArr.c1 = 'Arrived';
                titleArr.c2 = 'Started';
                return titleArr;
            } else if (title == 'Revenue') {
                titleArr.c1 = 'Goal'
                titleArr.c2 = 'Actual'
                return titleArr;
            }
            return titleArr;
        },
        today() {
            return moment().format('dddd, MMMM D, YYYY');
        },
        datechange() {
            var currentDate = moment(this.form.date);  // Assuming you have the current date
            this.weekdate = currentDate.clone().add(6, 'days').format('MM/DD/Y');
        },
        userchange()
        {
            if(this.form.UserID != 0)
            {
                this.user = this.users.find(user => user.id === this.form.UserID);
            }
            else
            {
                this.user = {}
            }
        }, 
        calDifference(goal, actual, rev = false) {
            let focus1Goal = Math.round(parseFloat(goal != null ? goal : 0));
            let focus1Actual = Math.round(parseFloat(actual != null ? actual : 0));
            let diff = focus1Actual - focus1Goal;

            if (diff < 0) {
                let absDiff = Math.abs(diff);
                return rev ? '-$' + absDiff : '-' + absDiff;
            } else {
                return rev ? '+$' + diff : '+' + diff;
            }
        },
        calculatePer(actual, goal) {
            actual = actual ?? 0;
            goal = goal ?? 0;
            let rate = 0;
            if (parseFloat(actual) !== 0 && parseFloat(goal) !== 0) {
                rate = Math.round((parseFloat(actual) / parseFloat(goal)) * 100);
            } else {
                rate = 0;
            }
            return rate;
        },
        weeklyReport() {
            console.log(this.form);
            userAPI.weeklyReport({
                PracticeID: this.loginUser.PracticeID,
                ...this.form
            },
                res => {
                    this.reports = res.data;
                },
                err => {
                    console.log(err);
                })
        },
        resetReport() {
            this.form = {
                UserID: 0,
                year: moment().format('Y'),
                FocusCode: this.focusData.FocusCode
            };
            this.getReportData();
        },
        printReport() {
            let print = document.getElementById('print-report');

            const doc = new jsPDF()
            doc.html(print, {
                callback: function (doc) {
                    doc.save("weekly-Report.pdf");
                },
                margin: [10, 10, 10, 10],
                autoPaging: 'text',
                x: 0,
                y: 0,
                width: 190,
                windowWidth: 875
            });
        },
        formatDate(date) {
            return moment(date).format('MMMM DD, YYYY');
        },
        getUsersByPractice() {
            this.isLoading = true;

            userAPI.getUsersByPractice({ practiceID: this.loginUser.PracticeID },
                res => {
                    res.data.data.forEach(element => {
                        this.users.push({
                            'id': element.UserID,
                            'name': `${element.FirstName} ${element.LastName}`
                        })
                    });
                    this.isLoading = false;
                },
                err => {
                    console.log(err);
                    this.isLoading = false;

                })
        },
        calculateColumnTotal(columnName, focusIndex) {
            if (!this.reports || !this.reports[focusIndex]) return 0;
            return this.reports[focusIndex].reduce((sum, daily) => {
                return sum + (parseFloat(daily[columnName]) || 0);
            }, 0);
        },

        // Calculate the total difference for a specific column
        calculateColumnTotalDifference(goalColumnName, actualColumnName, rev = false, focusIndex) {
            const totalGoal = this.calculateColumnTotal(goalColumnName, focusIndex);
            const totalActual = this.calculateColumnTotal(actualColumnName, focusIndex);
            return this.calDifference(totalGoal, totalActual, rev);
        },

        // Calculate the total success rate for a specific column
        calculateColumnTotalSuccessRate(actualColumnName, goalColumnName, focusIndex) {
            const totalActual = this.calculateColumnTotal(actualColumnName, focusIndex);
            const totalGoal = this.calculateColumnTotal(goalColumnName, focusIndex);
            return this.calculatePer(totalActual, totalGoal);
        },

    },
    mounted() {
        this.loginUser = JSON.parse(localStorage.getItem('userDetails'));
        this.getUsersByPractice()
        this.weeklyReport()
        this.datechange()
    },
    computed: {

    }
}

</script>
<style>
table.table.daily-repot-table tr td {
    border-color: #dddddd !important;
}
</style>